import React, { useEffect, useRef, useState } from "react";
import { Form, Input, InputNumber, Modal, Select, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice";
import {
  fetchActiveFiscMonth,
  fetchActiveFiscYear,
} from "../../../../features/dropdown/dropdownSlice";

const { TextArea } = Input;

const AddPayslipMessageModal = ({
  open,
  handleCancel,
  handleFetchData,
  prodd,
}) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { saving } = useSelector((state) => state.save);
  const { activeFiscYear, loading, activeFiscMonth } = useSelector(
    (state) => state.dropdown
  );

  const { personnelFolders } = useSelector((state) => state.folder);

  const [formData, setFormData] = useState(prodd);

  const onChange = async (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const onChangeOther = (value, fieldName) => {
    setFormData((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  async function handleSelectChange(value, formName) {
    await setFormData((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }

  const onFinish = async (data) => {
    if (!formData?.fpPyear) {
      toast.error("Please select year");
      return;
    }
    if (!formData?.fpPmonth) {
      toast.error("Please select month");
      return;
    }

    const res = await dispatch(
      save({
        smId: prodd?.smId ? prodd?.smId : null,
        fpPyear: formData?.fpPyear,
        fpPmonth: formData?.fpPmonth,
        smMsg: formData?.smMsg,

        url: "hr/savePrSlipMsg.action",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleFetchData();
      await setFormData({});
      await handleCancel();
      await form.resetFields();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  async function fetchActiveFiscYearData() {
    dispatch(fetchActiveFiscYear());
  }

  async function fetchActiveFiscMonthData() {
    dispatch(fetchActiveFiscMonth());
  }

  useEffect(() => {
    setFormData(prodd);
  }, [prodd]);

  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={
          prodd ? `Edit message for year ${prodd?.fpPyear}` : "Add payslip message details"
        }
        open={open}
        onOk={onFinish}
        onCancel={handleCancel}
        width={850}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
          <Form.Item
            className=""
            label="Period Year"
            rules={[
              {
                required: true,
                message: "Please select period year ",
              },
            ]}
          >
            <Select
              name="fpPyear"
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                activeFiscYear?.length > 0 &&
                activeFiscYear?.map((item) => ({
                  value: item?.fpPyear,
                  label: item?.fpPyear,
                }))
              }
              value={formData?.fpPyear}
              onChange={(value) => {
                handleSelectChange(value, "fpPyear");
              }}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
              onDropdownVisibleChange={() => {
                fetchActiveFiscYearData();
              }}
              dropdownRender={(menu) => (
                <>
                  {loading && (
                    <div
                      style={{
                        padding: "8px",
                        textAlign: "center",
                      }}
                    >
                      <Spin className="sms-spin" />
                    </div>
                  )}
                  {menu}
                </>
              )}
            />
          </Form.Item>

          <Form.Item
            className=""
            label="Period Month"
            rules={[
              {
                required: true,
                message: "Please select period month ",
              },
            ]}
          >
            <Select
              name="fpPmonth"
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                activeFiscMonth?.length > 0 &&
                activeFiscMonth?.map((item) => ({
                  value: item?.fpPmonth,
                  label: item?.fpPmonth,
                }))
              }
              value={formData?.fpPmonth}
              onChange={(value) => {
                handleSelectChange(value, "fpPmonth");
              }}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
              onDropdownVisibleChange={() => {
                fetchActiveFiscMonthData();
              }}
              dropdownRender={(menu) => (
                <>
                  {loading && (
                    <div
                      style={{
                        padding: "8px",
                        textAlign: "center",
                      }}
                    >
                      <Spin className="sms-spin" />
                    </div>
                  )}
                  {menu}
                </>
              )}
            />
          </Form.Item>

          <Form.Item
            label="Message"
            rules={[
              {
                required: true,
                message: "Enter message",
              },
            ]}
          >
            <TextArea
              required
              name="smMsg"
              onChange={onChange}
              value={formData?.smMsg}
              rows={4}
              className="input-textarea"
            />
          </Form.Item>

          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn !bg-white !text-lightBlack !border !border-lightBlack"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn"
                  disabled={saving}
                >
                  {saving ? <Spin /> : "Create"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default AddPayslipMessageModal;
